<template>
    <v-container>
        <div class="px-2 pb-5">
            <div>
                <div align="center" class="pt-10">
                    <img :src="require('@/assets/icons/inbox.svg')" />
                </div>

                <v-row class="justify-center">
                    <v-col cols="12" lg="6">
                        <v-card
                            variant="flat"
                            class="bg-lightblue my-3 rounded-10"
                        >
                            <v-card-text>
                                <div
                                    class="text-center font-weight-600 font-size-20 text-inkblue"
                                >
                                    Pesanan Berhasil Terbuat
                                </div>

                                <div
                                    class="text-center font-size-16 mt-2 text-inkblue"
                                >
                                    Terima kasih telah memesan paket belajar
                                    Skolla.
                                    <b>Invoice</b> pemesanan telah dikirim
                                    melalui <b>email</b>.
                                </div>
                            </v-card-text>
                        </v-card>

                        <v-card class="mt-4 border-1 rounded-8" flat>
                            <v-card-text>
                                <div class="font-size-16 font-weight-600">
                                    Detail Pembeli
                                </div>

                                <div class="mt-4">
                                    <v-row class="text-darkgrey">
                                        <v-col cols="6" md="6">
                                            Nama Siswa
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600"
                                        >
                                            {{ purchase_user?.student_name }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Nomor Whatsapp Siswa
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.student_phone }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Nama Orang Tua
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.parent_name }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Email Orang Tua
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.parent_email }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Nomor Whatsapp Orang Tua
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.parent_wa }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Sekolah Siswa
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{
                                                purchase_user?.student_school_name
                                            }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Jenjang
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.level }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Kelas
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{ purchase_user?.grade }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Sumber Informasi
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{
                                                purchase_user?.register_information_source ||
                                                '-'
                                            }}
                                        </v-col>

                                        <v-col cols="6" md="6" class="pt-0">
                                            Skema Pembayaran
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            {{
                                                setSchemeName(
                                                    purchase_user?.payment_scheme
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>

            <div>
                <v-row class="justify-center">
                    <v-col cols="12" lg="6">
                        <v-card class="mt-4 border-1 rounded-8" flat>
                            <v-card-text>
                                <div class="font-size-16 font-weight-600">
                                    Ringkasan Pembelian
                                </div>
                                <div class="mt-4">
                                    <v-row class="text-darkgrey">
                                        <v-col cols="6" md="6">
                                            {{ detail?.name }}
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600"
                                        >
                                            Rp
                                            {{
                                                formatNumber(
                                                    detail?.normal_price
                                                )
                                            }}
                                        </v-col>

                                        <v-col
                                            v-if="discount_status"
                                            cols="6"
                                            md="6"
                                            class="pt-0"
                                        >
                                            Potongan Harga
                                        </v-col>
                                        <v-col
                                            v-if="discount_status"
                                            cols="6"
                                            md="6"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            -Rp {{ package_discount || 0 }}
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        v-if="referral_code"
                                        class="text-darkgrey"
                                    >
                                        <v-col cols="12" md="7" class="pt-0">
                                            Potongan Kode Referral
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="5"
                                            class="text-right text-blacknew font-weight-600 pt-0"
                                        >
                                            -Rp
                                            {{
                                                formatNumber(
                                                    detail?.referral_discount
                                                ) || 0
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <hr class="dashed my-4" />

                                <v-row>
                                    <v-col
                                        cols="6"
                                        md="6"
                                        class="text-blacknew"
                                    >
                                        Total Pembayaran
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="6"
                                        class="text-right text-chilired font-weight-600 font-weight-600 text-chilired"
                                    >
                                        Rp
                                        {{ formatNumber(actual_price) }}
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-actions class="pt-5 px-3 pb-4">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <v-btn
                                            color="#e1f4fc"
                                            class="text-blew"
                                            variant="flat"
                                            rounded="pill"
                                            block
                                            size="large"
                                            @click="$router.push('/')"
                                        >
                                            Kembali
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="6" md="6">
                                        <v-btn
                                            color="#0e97d6"
                                            variant="flat"
                                            rounded="pill"
                                            block
                                            size="large"
                                            @click="openEmail()"
                                        >
                                            Buka Email
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    inject: ['display'],
    data() {
        return {
            loading: false,
            loading_payment: false,
            detail: {},
        };
    },

    computed: {
        package_id() {
            return this.$route.query.id;
        },

        purchase_user() {
            const data = localStorage.getItem('purchase_user');
            return JSON.parse(data);
        },

        package_discount() {
            const normal_price = this.detail?.normal_price;
            const discount = this.detail?.discount;
            const discount_amount = (normal_price * discount) / 100;

            return normal_price
                ? discount_amount.toLocaleString('id-ID', {
                      maximumFractionDigits: 0,
                  })
                : 0;
        },

        referral_code() {
            return localStorage.getItem('purchase_referral_code');
        },

        discount_status() {
            const discount = this.detail?.discount;
            const discount_exp_time = this.detail?.discount_exp_time;
            const now = this.$moment();
            let status = true;

            if (discount_exp_time) {
                if (this.$moment(discount_exp_time).isAfter(now)) {
                    status = true;
                } else {
                    status = false;
                }
            }

            if (!discount) {
                status = false;
            }

            return status;
        },

        actual_price() {
            const referral_code = localStorage.getItem(
                'purchase_referral_code'
            );

            let actual_price = this.discount_status
                ? this.detail?.actual_price
                : this.detail?.normal_price;

            if (referral_code) {
                actual_price =
                    this.detail?.actual_price - this.detail?.referral_discount;
            }

            return actual_price || 0;
        },
    },

    mounted() {
        this.getPackageDetail();
    },

    methods: {
        async getPackageDetail() {
            this.loading = true;
            try {
                this.detail = await this.$axios.get(
                    `payment/package/${this.package_id}/detail/wp`
                );
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        formatNumber(val = 0) {
            return val.toLocaleString('id-ID');
        },

        openEmail() {
            window.open('https://mail.google.com/mail', '_blank');
        },

        setSchemeName(val) {
            if (val === 'full_payment') {
                return 'Full Payment';
            }

            if (val === 'dp_payment') {
                return 'Dp 10%';
            }

            if (val === 'installment_payment') {
                return 'Cicilan 2x';
            }
        },
    },
};
</script>

<style>
.v-expansion-panel__shadow {
    box-shadow: none !important;
}

.custom-radio .v-selection-control__input {
    margin-top: -20px !important;
}

.sticky-col {
    position: sticky !important;
    top: 70px;
    align-self: flex-start;
}
</style>
